import store from './index';
export const selectOpenedFilter = () => store((state) => state.openedFilter);
export const selectFiltersData = () => store((state) => state.filtersData);
export const selectContentManagers = () => store((state) => state.contentManagers);
export const calculateFiltersCounts = (filters) => {
    const showMe = Number(!!(filters.favorite
        || filters.onlyUsersCompany
        || filters.distress));
    const availability = Number(!!(filters.hasOffPlan
        || filters.hasResale
        || filters.statuses?.includes('launch')
        || filters.statuses?.includes('sold_out')));
    const price = Number(!!(filters.minPrice || filters.maxPrice || filters.hasPostHandover));
    const size = Number(!!(filters.minSquare || filters.maxSquare));
    const pricePerSquare = Number(!!(filters.pricePerAreaFrom || filters.pricePerAreaTo));
    const downPayment = Number(!!(filters.downPaymentFrom || filters.downPaymentTo));
    const downPaymentAmount = Number(!!(filters.downPaymentAmountFrom || filters.downPaymentAmountTo));
    const handover = Number(!!(filters.handoverFrom || filters.handoverTo || !!filters.isBuilt || filters.offPlan));
    const layout = Number(!!filters.layouts?.length);
    const unitType = Number(!!filters.unitTypeIds?.length);
    const unitLevel = Number(!!filters.unitLevels?.length);
    const furnishing = Number(!!filters.finishingIds?.length);
    const unitFeatures = Number(!!filters.featureIds?.length);
    const serviceCharge = Number(!!(filters.minServiceCharge || filters.maxServiceCharge));
    const responsibleEmployee = Number(!!filters.contentManagerId);
    const unitsRequireVerification = Number(!!filters.hasProblem);
    return {
        emirate: filters.emirateIds?.length,
        district: filters.districtIds?.length,
        developer: filters.companyIds?.length,
        other: showMe + availability + price + size + pricePerSquare
            + downPayment + downPaymentAmount + handover
            + layout + unitType + unitLevel + furnishing
            + unitFeatures + serviceCharge + responsibleEmployee + unitsRequireVerification,
    };
};
export const calculateMobileFiltersCounts = (filters) => {
    const availability = Number(!!(filters.hasOffPlan
        || filters.hasResale
        || filters.statuses?.includes('launch')
        || filters.statuses?.includes('sold_out')));
    const highlightOnMap = Number(!!(filters.favorite || filters.onlyUsersCompany || filters.distress));
    const handover = Number(!!(filters.handoverFrom || filters.handoverTo || !!filters.isBuilt || filters.offPlan));
    const price = Number(!!(filters.minPrice || filters.maxPrice));
    const pricePerSquare = Number(!!(filters.pricePerAreaFrom || filters.pricePerAreaTo));
    const size = Number(!!(filters.minSquare || filters.maxSquare));
    const unitLevel = Number(!!filters.unitLevels?.length);
    const ownershipType = Number(!!filters.ownershipType);
    const layout = Number(!!filters.layouts?.length);
    const unitType = Number(!!filters.unitTypeIds?.length);
    const furnishing = Number(!!filters.finishingIds?.length);
    const unitFeatures = Number(!!filters.featureIds?.length);
    const serviceCharge = Number(!!(filters.minServiceCharge || filters.maxServiceCharge));
    const downPayment = Number(!!(filters.downPaymentFrom || filters.downPaymentTo || filters.hasPostHandover));
    const responsibleEmployee = Number(!!filters.contentManagerId);
    const unitsRequireVerification = Number(!!filters.hasProblem);
    return {
        location: (filters.emirateIds?.length ?? 0) + (filters.districtIds?.length ?? 0),
        company: filters.companyIds?.length ?? 0,
        other: (availability
            + highlightOnMap
            + handover
            + price
            + pricePerSquare
            + size
            + unitLevel
            + ownershipType
            + layout
            + unitType
            + furnishing
            + unitFeatures
            + serviceCharge
            + downPayment
            + responsibleEmployee
            + unitsRequireVerification),
    };
};
export default {
    setFilters: store.getState().setFilters,
    changeFilters: store.getState().changeFilters,
    changeOpenedFilter: store.getState().changeOpenedFilter,
    clearFilters: store.getState().clearFilters,
    getContentManagers: store.getState().getContentManagers,
};
